import React, { useEffect, useRef } from 'react';
import Modal from 'react-modal';
import './Modal.css';

// Set app element for accessibility
if (typeof document !== 'undefined') {
    Modal.setAppElement('#root');
}

const LogoutModal = ({ onClose, children, ariaLabel }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        // Trap focus within modal
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }

            if (e.key === 'Tab' && modalRef.current) {
                const focusableElements = modalRef.current.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return (
        <Modal
            isOpen={true} 
            onRequestClose={onClose}
            className="logout-modal"
            overlayClassName="logout-overlay"
            appElement={document.getElementById('root')}
            aria={{
                labelledby: 'logout-modal-title',
                describedby: 'logout-modal-description'
            }}
            role="alertdialog"
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={true}
        >
            <div className="modal-content" ref={modalRef} role="document">
                {children}
            </div>
        </Modal>
    );
};

export default LogoutModal;
